import React from 'react';
import { Link } from 'react-router-dom';
import Legal from '../../components/layouts/legal';

const Terms = () => (
  <Legal title="Terms & Conditions" lastUpdated="October 19, 2026">
    <p>
      These Terms &amp; Conditions govern your use of the ADM Client Portal
      (https://cp.admone.app), operated by ADM CPA P.C. ("ADM CPA", "we", "us"), and the text
      messages we send to you. By using the Client Portal or opting in to text messages, you agree
      to these terms.
    </p>

    <h2>About Us</h2>
    <p>
      ADM CPA P.C. is an accounting firm providing bookkeeping, tax preparation, tax planning, and
      business consulting services. The ADM Client Portal is where our clients securely share
      documents, review company information, track tasks, and message our team.
    </p>

    <h2>SMS Messaging Program</h2>
    <p>
      By providing your mobile phone number, you agree to receive text messages from ADM CPA P.C. at
      the number provided, sent using an automated system. These messages relate to your account and
      our services, such as one-time login verification codes, document requests, task and deadline
      reminders, and account notifications.
    </p>
    <ul>
      <li><strong>Consent:</strong> Consent is not a condition of purchase or of receiving our services.</li>
      <li><strong>Frequency:</strong> Message frequency varies.</li>
      <li><strong>Rates:</strong> Message and data rates may apply.</li>
      <li><strong>Opt out:</strong> Reply <strong>STOP</strong> to any text message from us to cancel at any time. You will receive one final message confirming you have been unsubscribed.</li>
      <li><strong>Help:</strong> Reply <strong>HELP</strong> to any text message from us for help.</li>
      <li>
        <strong>Support:</strong> For additional assistance, contact us
        at <a href="mailto:info@admcpapc.com">info@admcpapc.com</a> or <a href="tel:+17133373100">(713) 337-3100</a>.
      </li>
    </ul>
    <p>
      Carriers are not liable for any delayed or undelivered messages. See
      our <Link to="/privacy-policy">Privacy Policy</Link> for how we handle your personal
      information.
    </p>

    <h2>Your Account</h2>
    <p>
      You are responsible for keeping your login credentials confidential and for activity under
      your account. Let us know promptly if you believe your account has been accessed without your
      permission.
    </p>

    <h2>Acceptable Use</h2>
    <p>
      Use the Client Portal only to exchange information related to the services we provide to you.
      Do not upload unlawful content or attempt to access data that does not belong to you.
    </p>

    <h2>Use of Artificial Intelligence</h2>
    <p>
      We use AI tools to assist our team, such as suggesting document names and helping draft
      messages. Every AI suggestion is reviewed by our staff, and AI-assisted content is not by
      itself professional accounting or tax advice. See our <Link to="/privacy-policy">Privacy
      Policy</Link> for how your information is handled.
    </p>

    <h2>Changes to These Terms</h2>
    <p>
      We may update these Terms from time to time. The "Last Updated" date above shows when they were
      last revised. Continued use of the Client Portal or our text messages after a change means you
      accept the updated terms.
    </p>

    <h2>Contact Us</h2>
    <address>
      ADM CPA P.C.<br />
      Email: <a href="mailto:info@admcpapc.com">info@admcpapc.com</a><br />
      Phone: <a href="tel:+17133373100">(713) 337-3100</a>
    </address>
  </Legal>
);

export default Terms;
